import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class ContractDA {
  static apiResponse: ApiResponse

  public static async getContracts(
    id_company: string,
    id_employee: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/employees/${id_employee}/contracts`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getCurrentContract(
    id_company: string,
    id_employee: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/employees/${id_employee}/contracts/current`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async postContract(
    id_company: string,
    id_employee: string,
    body: any
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/employees/${id_employee}/contracts`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async uploadVoucher(
    id_company: string,
    id_contract: string,
    file: File,
    role?: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/contracts/${id_contract}/vouchers/upload`

    let formData = new FormData()
    formData.append('file', file)
    formData.append('role', role || 'employment_contract')

    let config: any = {
      headers: { Authorization: authToken(), 'Content-Type': 'multipart/form-data' }
    }

    await axios.post(url, formData, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async attachVoucher(
    id_company: string,
    id_contract: string,
    body: { id_document_inbox: string; role?: string }
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/contracts/${id_contract}/vouchers`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async deleteVoucher(
    id_company: string,
    id_contract: string,
    id_document: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/contracts/${id_contract}/vouchers/${id_document}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async terminateContract(
    id_company: string,
    id_employee: string,
    id_contract: string,
    body: { end_date: string; end_reason: string }
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/employees/${id_employee}/contracts/${id_contract}/terminate`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.post(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async cancelTermination(
    id_company: string,
    id_employee: string,
    id_contract: string
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/employees/${id_employee}/contracts/${id_contract}/terminate`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.delete(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async putContract(
    id_company: string,
    id_employee: string,
    id_contract: string,
    body: any
  ): Promise<ApiResponse> {
    let url = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/payroll/employees/${id_employee}/contracts/${id_contract}`

    let config: any = {
      headers: { Authorization: authToken() }
    }

    await axios.put(url, body, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }
}
